import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SurveyService } from '../../../core/services/survey/survey.service';
import { Habit, HabitQuestion } from '../../../core/models/survey/habit.model';
import { HABIT_QUESTIONS } from '../../../../enums/habit-questions.enum';
@Component({
  selector: 'app-habits-form',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule],
  templateUrl: './habits-form.component.html',
  styleUrl: './habits-form.component.scss',
})
export class HabitsFormComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Output() nextStepEvent = new EventEmitter<void>();

  constructor(private surveyService: SurveyService) {}

  ratingValues = Array.from({ length: 10 }, (_, i) => i + 1);
  habits: Habit[] = [];
  serverHabitQuestions: HabitQuestion[] = [];
  habitQuestions: any[] = [];
  controlMapping: { [key: string]: string } = {
    [HABIT_QUESTIONS.HEALTHY_EATING]: 'healthyEating',
    [HABIT_QUESTIONS.TAKE_MEDICATIONS]: 'takeMedications',
    [HABIT_QUESTIONS.MONITOR_DISEASE]: 'monitorDisease',
    [HABIT_QUESTIONS.ACTIVE]: 'active',
    [HABIT_QUESTIONS.STRESS_LEVEL]: 'stressLevel',
    [HABIT_QUESTIONS.HYP_ATTACKS]: 'hypoglycemicAttacks',
    [HABIT_QUESTIONS.LOW_SODIUM]: 'lowSodium',
    [HABIT_QUESTIONS.EXERCISE]: 'exercise',
    [HABIT_QUESTIONS.EXERCISE_DURATION]: 'exerciseDuration',
  };
  labelMapping: { [key: string]: string } = {
    [HABIT_QUESTIONS.HEALTHY_EATING]: 'healthyEatingHabit',
    [HABIT_QUESTIONS.TAKE_MEDICATIONS]: 'takeMedicationsOnTime',
    [HABIT_QUESTIONS.MONITOR_DISEASE]: 'monitorMyDisease',
    [HABIT_QUESTIONS.ACTIVE]: 'iAmActive',
    [HABIT_QUESTIONS.STRESS_LEVEL]: 'iDontFeelStress',
    [HABIT_QUESTIONS.HYP_ATTACKS]: 'iDontHaveHypoglycemicAttacks',
    [HABIT_QUESTIONS.LOW_SODIUM]: 'lowSodium',
    [HABIT_QUESTIONS.EXERCISE]: 'exercise',
    [HABIT_QUESTIONS.EXERCISE_DURATION]: 'exerciseDuration',
  };

  ngOnInit(): void {
    this.getPreparationPageSurveys();
  }

  getPreparationPageSurveys() {
    this.surveyService.getPreparationPageSurveys().subscribe((res) => {
      this.habits = res;
      if (this.habits && this.habits.length > 0 && this.habits[0].questions) {
        this.serverHabitQuestions = this.habits[0].questions;
        this.transformHabitQuestions();
      }
    });
  }

  transformHabitQuestions() {
    this.habitQuestions = this.serverHabitQuestions.map((question) => {
      const controlName = this.controlMapping[question.id] || question.id;
      const label = this.labelMapping[question.id] || question.text;
      const type = question.answerType === 1 ? 'select' : 'radio';

      const options =
        question.answerType === 1
          ? question.answerOptions.map((option, index) => ({
              value: index + 1,
              text: option.answerText,
              score: option.score,
              id: option.id || option.score,
            }))
          : [];

      return {
        id: question.id,
        controlName,
        label,
        type,
        text: question.text,
        ...(options.length > 0 && { options }),
      };
    });
  }

  goToNextStep(): void {
    if (this.formGroup.invalid) {
      this.markFormGroupTouched(this.formGroup);
      return;
    }
    this.nextStepEvent.emit();
  }

  isControlInvalid(controlName: string): boolean {
    const control = this.formGroup.get(controlName);
    return control
      ? control.invalid && (control.dirty || control.touched)
      : false;
  }

  private markFormGroupTouched(formGroup: FormGroup) {
    Object.values(formGroup.controls).forEach((control) => {
      control.markAsTouched();
    });
  }
}
